
const hsbmsDialog = {
  state: {
    hsbmsState: false,
    hsbmsArr: [],
  },

  mutations: {
    SET_HSBMSSTATE: (state, val) => {
      state.hsbmsState = val
    },
    SET_HSBMSARR: (state, val) => {
      state.hsbmsArr = JSON.parse(JSON.stringify(val))
    }
  },
  actions: {}
}
export default hsbmsDialog
